export const sdkConfig = {
    appkey: 'AAKkgYqnwSZW',
    appsecret: 'A1u7XrgP8pa5csNADziQLhjwEynl2O6v',
    nv: 1
}